import { gql } from "@apollo/client";
import { useResettableMutation } from "../useResettableMutation";
import { getErrors } from "../../utils/apolloError";
import { AsyncActionStatus } from "../../models/AsyncActionStatus";
import { SetMaxProjectAssignments, SetMaxProjectAssignmentsVariables } from "./__generated__/SetMaxProjectAssignments";
import { CORE_PROJECT_FIELDS } from "../fragments/project";

const SET_MAX_PROJECT_ASSIGNMENTS = gql`
  ${CORE_PROJECT_FIELDS}
  mutation SetMaxProjectAssignments($projectId: String!, $max: Int, $organizationId: String!) {
    setMaxProjectAssignments(input: { projectId: $projectId, max: $max, organizationId: $organizationId }) {
      project {
        ...CoreProjectFields
        maxProjectAssignments
      }
    }
  }
`;

export function useSetMaxProjectAssignments() {
  const [mutate, { loading, data, error, reset, called }] = useResettableMutation<
    SetMaxProjectAssignments,
    SetMaxProjectAssignmentsVariables
  >(SET_MAX_PROJECT_ASSIGNMENTS, {
    errorPolicy: "all",
  });
  return {
    mutate,
    data,
    status: {
      loading,
      reset,
      called,
      errors: getErrors(error),
      successful: !error && data ? true : false,
    } as AsyncActionStatus,
  };
}
